import type { VAxios } from '../../define/axios/Axios';

export const createApi = (defHttp: VAxios) => ({
  // 获取图文模板列表
  getTemplateList: (params) => {
    return defHttp.post({ url: `/aiad/graphic-text/templates/list`, params });
  },
  // 保存图文模板
  createTemplate: (params) => {
    return defHttp.post({ url: `/aiad/graphic-text/templates`, params });
  },
  // 更新图文模板
  updateTemplate: (id, params) => {
    return defHttp.put({ url: `/aiad/graphic-text/templates/${id}`, params });
  },
  // 图文模板详情
  getTemplateDetail: (id) => {
    return defHttp.get({ url: `/aiad/graphic-text/templates/${id}` });
  },
  // 删除图文模板
  deleteTemplate: (id) => {
    return defHttp.delete({ url: `/aiad/graphic-text/templates/${id}` });
  },

  // 解析 excel 文件
  parseExcel: (params) => {
    return defHttp.post({ url: `/aiad/graphic-text/tasks/parse`, params });
  },

  // 获取Job列表
  getJobList: (params) => {
    return defHttp.get({ url: `/aiad/graphic-text/jobs`, params });
  },

  // 提交任务job
  createJob: (params) => {
    return defHttp.post({ url: `/aiad/graphic-text/jobs`, params });
  },
  // 获取task列表
  getTaskList: (params) => {
    return defHttp.get({ url: `/aiad/graphic-text/jobs/tasks`, params });
  },

  // 到处 job 结果图
  exportJob: (params) => {
    return defHttp.get({ url: `/aiad/graphic-text/jobs/export`, params });
  },

  getExportPages: (params) => {
    return defHttp.get({ url: `/aiad/graphic-text/jobs/export/pages`, params });
  },
});
